import config from "../seo/config.json";
import { API_ENDPOINTS } from "../constants/api-endpoints";

export const CARD_IMAGE_SIZES = config.images.cardSizes;
export const HERO_IMAGE_SIZES = config.images.heroSizes;

export function productImageSources(id, widths = [360, 720, 1200]) {
  return widths.map(width => `${API_ENDPOINTS.GET_THUMBNAIL(width, id)} ${width}w`).join(", ");
}
